import { render, staticRenderFns } from "./local-sample-types-grid.vue?vue&type=template&id=3c38906a&scoped=true&"
import script from "./local-sample-types-grid.ts?vue&type=script&lang=ts&"
export * from "./local-sample-types-grid.ts?vue&type=script&lang=ts&"
import style0 from "./local-sample-types-grid.scss?vue&type=style&index=0&id=3c38906a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38906a",
  null
  
)

export default component.exports